import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationType } from '../backend-types/misc-types';
import { EventType } from '../ballot/ballot.service';
import { SessionService } from '../Services/session.service';

@Component({
    selector: 'app-declined',
    templateUrl: './declined.component.html',
    styleUrls: ['./declined.component.scss'],
    standalone: false
})
export class DeclinedComponent  {
  confirmationType: ConfirmationType | undefined;
  confirmationId: string | undefined;
  ballotType?: EventType;
  
  constructor(private readonly sessionService: SessionService,
    private readonly router: Router,
  ) { 
    this.confirmationId = history.state.confirmationId;
    this.confirmationType = history.state.confirmationType;
    this.ballotType = history.state.ballotType;
  }

  print(): void {
    window.print();
  }

  exit(): void {
    this.sessionService.finishedVoting()
  }

  emailUsed(): boolean {
    return this.confirmationType?.includes('EMAIL') ?? false;
  }

  spaceOut(text?: string) {
    return text ? text.split('').join(' ') : "";
  }
}
